@if (component) {
<div class="pos-relative flex flex-middle flex-column-s flex-column-m"
     [style.gap.px]="[16, 32, 40, 40][client.sizeId]">
    @for(image of component.images; track $index) {
    <div class="w-12 pos-relative"
         [class]="image.roundedCorners ? '_border-radius overflow-hidden' : ''">
        <df-image-wrapper class="w-12">
            <img class="w-12"
                 [ratio]="image.ratio || '16/9'"
                 [loaderParams]="{quality: 100}"
                 [dfImage]="image.image"
                 alt="">
        </df-image-wrapper>
        <div class="_content p-a-4-s p-a-8-m p-a-10-l p-a-30-x z-1"
             [ngClass]="[getPositionClasses(image), image.overlay ? image.overlayType : '']">
            <text-box class="_text-box"
                      [data]="image" />
            <!-- full-bleed click catcher: it has no content of its own, so it
                 reaches screen readers unlabelled. The projected span is
                 visually hidden but gives the anchor its accessible name. -->
            <href [link]="image.link"
                  hrefClass="block w-12 height-100"
                  class="pos-absolute top-0 left-0 right-0 bottom-0">
                <span class="visually-hidden">{{ image.title || 'View more' }}</span>
            </href>
        </div>
    </div>
    }
</div>
}